(function() {
    'use strict';

    console.log('Build: May 10 11:02pm');
    var WebFont = require('webfontloader');

    var crossroads = require('crossroads');
    var hasher = require('hasher');

    var $ = require('jquery');

    var tracker = require('./tracking');
    var config = require('./config');
    var mainView = require('./main_view');
    var questionsData = require('./questions');

    var modalView = require('./modal');
    var modalShareView = require('./modal_share');

    var chairs = require('./chairs');
    var dataFetch = require('./dataFetch');
    var chairsDebugView = require('./chairs_debug_view');

    var attachFastClick = require('fastclick');
    attachFastClick(document.body);

    var userAnsweredQuestions = [];
    var currentQuestionID = null;
    var currentQuestionIndex = 0;

    var debug = false;
    if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.7' ||window.location.hostname === '10.0.2.2' || window.location.hostname === 'selector.hmibrand.com') {
        debug = true;
        console.log('debug is true', window.location.hostname);
    } else {
        console.log('debug is false', window.location.hostname);
    }


    var currentResultsHash = '';
    var questionsType = '';

    var router = (function() {
        var chairDetailsKeys;

        if (config.getQuery('chairs').length === 6) {
            var chairIDs = config.getQuery('chairs');
            if (typeof history !== 'undefined' && typeof history.pushState !== 'undefined') {
                history.pushState(null, '', location.href.split('?')[0]);
            }
            setHashSilently('results/' + chairIDs);

        }

        function parseHash(newHash) {
            crossroads.parse(newHash);
            var results = newHash.split('/');
            
            if (!results.length) {
                console.warn('No route detected. Returning to home page.');
                hasher.replaceHash('');
            } else {
                var section = results[0];
                if (section === 'personal' || section === 'business') {
                    showQuestions(section);
                } else if (section === 'results') {

                    if (debug === true && results[1] === 'all') {


                        $('.selector-container').css({
                            width: '500%',
                            'max-width': '500%'
                        });
                        results = chairs.getAll();
                        var resultDetailsFilenames = [];

                        results.forEach(function(chair) {
                            resultDetailsFilenames.push(chair.detailsFilename);
                        });
                        showResults(resultDetailsFilenames);

                    } else if (results.length > 1) {
                        var chairString = results[1];
                        var chairIds = chairString.match(/.{2}/g);
                        var validChairsFound = [];
                        chairIds = chairIds.splice(0, 3);
                        chairIds.forEach(function(id) {
                            var results = $.grep(chairDetailsKeys, function(e) {
                                return e.id === id;
                            });
                            if (results.length) {
                                validChairsFound.push(results[0].filename);
                            } else {
                                console.warn('Id "' + id + '" not associated with a chair');
                            }
                        });

                        if (validChairsFound.length >= 3) {
                            currentResultsHash = chairString;
                            showResults(validChairsFound, currentResultsHash);
                        }

                    }

                } else if (section === '') {
                    showHome();
                } else {
                    console.warn('Invalid route. Returning to home page.');
                    hasher.replaceHash('');
                }
            }
        }

        function init(chairDetails) {
            chairDetailsKeys = chairDetails;
            hasher.initialized.add(parseHash); //parse initial hash
            hasher.changed.add(parseHash); //parse hash changes
            hasher.init(); //start listening for history change
        }

        function setHashSilently(hash) {
            hasher.changed.active = false; //disable changed signal
            hasher.setHash(hash); //set hash without dispatching changed signal
            hasher.changed.active = true; //re-enable signal
        }


        function showHome() {
            modalView.hide();
            modalShareView.hide();

            mainView.clearResults();
            currentQuestionIndex = 0;
            userAnsweredQuestions = [];
            mainView.showIntro();

            tracker.setPage('/intro', 'Intro');
        }

        function showQuestions(trackType) {
            modalView.hide();
            modalShareView.hide();

            currentQuestionIndex = 0;
            userAnsweredQuestions = [];

            questionsType = trackType;

            questionsData.setType(trackType);
            mainView.beginQuestions(questionsData.list.length);
            mainView.setToPersonalTrack(trackType === 'personal');
            var firstQuestion;
            firstQuestion = questionsData.getQuestionByIndex(0).queryID;
            setQuestion(firstQuestion, true);

            //
        }

        function showResults(resultDetailsFilenames, hash) {
            modalShareView.updateHash(hash);


            modalView.hide();
            modalShareView.hide();

            loadResults(resultDetailsFilenames);
            mainView.showResults();

            var page = '';
            resultDetailsFilenames.forEach(function(filename, index) {
                var chair = filename.split('.')[0];
                page += chair;
                if (index < 2) {
                    page += '+';
                }
            });

            tracker.setPage('/results/' + page, 'Results');
        }


        function gotoIntro() {
            setHashSilently('');
            showHome();
        }

        function gotoQuestions(trackType) {
            setHashSilently(trackType);
            showQuestions(trackType);
        }

        function gotoResults(resultDetailsFilenames) {
            //figure link for these chairs
            var idsFound = [];
            resultDetailsFilenames.forEach(function(filename) {
                var results = $.grep(chairDetailsKeys, function(e) {
                    return e.filename === filename;
                });
                if (results.length) {
                    idsFound.push(results[0].id);
                } else {
                    console.warn('filename "' + filename + '" not associated with a chair ID');
                }
            });
            currentResultsHash = '';
            if (idsFound.length === 3) {
                currentResultsHash = idsFound.join('');
            } else {
                console.warn('unable to create chair link');
            }

            setHashSilently('results/' + currentResultsHash);
            showResults(resultDetailsFilenames, currentResultsHash);
        }

        return {
            init: init,

            gotoIntro: gotoIntro,
            gotoQuestions: gotoQuestions,
            gotoResults: gotoResults

            // startQuestions: startQuestions,
            // setResults: setResults
        };
    })();


    //update URL fragment generating new history record
    // hasher.setHash('lorem/ipsum');

    $(window).on('scroll', function() {
        var top = $(window).scrollTop();
        if (top > 520) {
            mainView.showSticky(true);
        } else {
            mainView.showSticky(false);
        }
    });
    mainView.onWhy(function(body, query) {

        tracker.trackEvent({
            category: 'Chair Selector',
            action: 'view help',
            label: query
        });
        modalView.show({
            'title': 'Why are we asking?',
            'body': body
        });
    });



    // var lockedAttributes = []; //skip any questions that would affect locked attributes



    var recalculatePoints = function(answeredQuestions) {


        // var points = {
        //     group1: 0,
        //     group2: 0,
        //     group3: 0,
        //     group4: 0,
        //     group5: 0,
        //     group6: 0
        // };

        // lockedAttributes = [];
        chairs.resetIdealChair();

        function calculate(questionAndAnswer) {
            var q = questionAndAnswer.questionData;
            var a = questionAndAnswer.answerNumber;

            var answer = q.answers[a];

            for (var i = 0; i < answer.attrPoints.length; i++) {
                var updateVar = answer.attrPoints[i];
                chairs.updateIdeal(updateVar.attr, updateVar.value);

                // if (updateVar.locked === true) {
                //     lockedAttributes.push(updateVar.attr);
                // }
            }
        }

        answeredQuestions.forEach(function(questionAndAnswer) {
            if (questionAndAnswer.questionData.isGroup !== true) {
                calculate(questionAndAnswer);
            } else {
                questionAndAnswer.questions.forEach(function(qa) {
                    calculate(qa);
                });
            }
        });

        chairs.orderList();

        // var orderedArrayOfPoints = [];

        // for (var group in points) {
        //     if (points.hasOwnProperty(group)) {
        //         orderedArrayOfPoints.push({
        //             name: group,
        //             points: points[group]
        //         });
        //     }
        // }

        // orderedArrayOfPoints.sort(function(a, b) {
        //     return b.points - a.points;
        // });


    };

    var handleAnswerSelected = function(questionAndAnswer) {
        if (userAnsweredQuestions.length === currentQuestionIndex) {
            userAnsweredQuestions.push(questionAndAnswer);
        } else {
            userAnsweredQuestions[currentQuestionIndex] = questionAndAnswer;
        }

        window.a = userAnsweredQuestions;

        recalculatePoints(userAnsweredQuestions);
        chairsDebugView.update(chairs.ideal, chairs.list);
    };

    function trackCompletedAnswers(questionAndAnswers) {
        //Chair Selector, gender, prefer not to respond, true
        //(Q) Personal: {question text}
        //
        function trackAnswer(qa) {
            // console.log(qa);
            var question = '(Q) ' + questionsType + ': ' + qa.questionData.getQueryText();
            var answerNumber = qa.answerNumber;
            var answer = qa.questionData.answers[answerNumber].text;
            // var eventName = '(Q) ' + questionsType + ': ';
            tracker.trackEvent({
                category: 'Chair Selector',
                action: question,
                label: answer,
                nonInteraction: true
            });
        }
        questionAndAnswers.forEach(function(qa) {
            if (qa.questionData.isGroup !== true) {
                trackAnswer(qa);
            } else {
                qa.questions.forEach(function(qa_sub) {
                    trackAnswer(qa_sub);
                });
            }

        });

    }

    function finishedQuestions() {
        console.log(userAnsweredQuestions);
        var resultDetailsFilenames = [];

        var results;
        results = chairs.getTop(3);



        results.forEach(function(chair) {
            resultDetailsFilenames.push(chair.detailsFilename);
        });

        router.gotoResults(resultDetailsFilenames);
        trackCompletedAnswers(userAnsweredQuestions);

    }

    var setQuestion = function(questionID, resetAnswer) {
        currentQuestionID = questionID;

        recalculatePoints(userAnsweredQuestions);
        chairsDebugView.update(chairs.ideal, chairs.list);

        mainView.enableView(questionID, currentQuestionIndex, (currentQuestionIndex === 0), resetAnswer);

        // tracking.setPage('/questin')
        if (questionID === 'complete') {
            finishedQuestions(userAnsweredQuestions);
        } else {
            var questionNumber = currentQuestionIndex + 1;
            var questionsPage = questionNumber + '-' + questionID;
            var pagePath = '/questions-' + questionsType + '/' + questionsPage;
            var pageTitle = questionNumber + '. ' + questionsData.getQuestionWithId(questionID).getQueryText();

            tracker.setPage(pagePath, pageTitle);
        }
        // else if (currentQuestionIndex === 0) {
        //     // mainView.showIntro();

        // }

    };

    var gotoPreviousQuestion = function(gotoQuestionIndex) {

        if (typeof gotoQuestionIndex === 'undefined') {
            //origin style with previous button
            currentQuestionIndex -= 1;
        } else {
            //new style with dimmer, can but summoned from any question
            if (gotoQuestionIndex >= currentQuestionIndex) {

                return;
            }
            currentQuestionIndex = gotoQuestionIndex;

        }

        if (currentQuestionIndex <= -1) {
            router.gotoIntro();
        } else {
            var prevQuestionAndAnswer = userAnsweredQuestions[currentQuestionIndex];
            var q = prevQuestionAndAnswer.questionData;
            var questionID = q.queryID;

            // userAnsweredQuestions = userAnsweredQuestions.slice(0, currentQuestionIndex);
            userAnsweredQuestions = userAnsweredQuestions.slice(0, currentQuestionIndex + 1);
            window.a = userAnsweredQuestions;
            setQuestion(questionID, false);
        }
    };


    var gotoNextQuestion = function() {

        currentQuestionIndex += 1;
        var nextQuestionID;
        if (questionsData.list.length === currentQuestionIndex) {
            nextQuestionID = 'complete';
        } else {
            nextQuestionID = questionsData.getQuestionByIndex(currentQuestionIndex).queryID;
        }


        setQuestion(nextQuestionID, true);
    };

    function getFields(input, field) {
        var output = [];
        for (var i=0; i < input.length ; ++i)
            output.push(input[i][field]);
        return output;
    }

    function loadResults(arrayOfFilenames) {
        var chairDetails = [];
        var loadResultNumber = 0;

        function loadNextResult() {
            var filename = arrayOfFilenames[loadResultNumber];

            dataFetch.load('data/chair_details/' + filename, function(data) {

                chairDetails.push(data);
                loadResultNumber += 1;

                if (loadResultNumber === arrayOfFilenames.length) {

                    mainView.displayChairDetails(chairDetails);
                    modalShareView.updateFirstChoiceChair(chairDetails[0].title_long);

                    // this will expose all 3 chair titles as allChairs in modal_share.js

                    var chairTitles = getFields(chairDetails, "title_long").toString();

                    // you could also use map, but it's not supported in IE9 + strict mode
                    // var chairTitles = chairDetails.map(function(a) {return a.title_long;});

                    var chairTitlesString = chairTitles;
                    var chairTitlesFormatted = chairTitlesString.replace(/,/g, ", ").replace(/,(?=[^,]*$)/, ', and');

                    modalShareView.updateChairTitles(chairTitlesFormatted);

                } else {
                    loadNextResult();
                }
            });


        }
        loadNextResult();
    }

    function handleBeginSelected(trackType) {
        router.gotoQuestions(trackType, true);
    }

    function loadChairAttributes(data) {
        var dataPathURL = data.paths.data;

        dataFetch.load(dataPathURL, function(pathsdata) {
            chairs.setData(pathsdata);

            mainView.start(questionsData, data.landing_images);
            mainView.onAnswerSelect(handleAnswerSelected);
            mainView.onNext(gotoNextQuestion);
            mainView.onPrevious(gotoPreviousQuestion);
            mainView.onRestart(router.gotoIntro);
            mainView.onBegin(handleBeginSelected);


            router.init(data.details);

        });
    }

    function begin() {
        dataFetch.load('config.json', function(data) {
            config.storeConfigJSON(data);
            loadChairAttributes(data);
        });
        $('.selector-footer').show();

        if (debug === true) {
            $('.selector-footer-copyright').on('click', function() {
                chairsDebugView.toggle();
            });
        }
    }
    WebFont.load({
        custom: {
            families: ['MetaNormal', 'MetaBold', 'MetaBlack']
        },
        // loading: function() {
        //     // console.log('loading');
        // },
        active: function() {
            begin();
            // console.log('active');
        },
        inactive: function() {
                begin();
                // console.log('inactive');
            }
            //,
            // fontloading: function(familyName, fvd) {
            //     // console.log('fontloading', familyName, fvd);
            // },
            // fontactive: function(familyName, fvd) {
            //     // console.log('fontactive', familyName, fvd);
            // },
            // fontinactive: function(familyName, fvd) {
            //     // console.log('fontinactive', familyName, fvd);
            // }
    });
    // var WebFontConfig = {
    //     custom: {
    //         families: ['MetaBlack'],
    //         urls: ['css/styles.css']
    //     }
    // };
    // begin();
})();
